import { type Dispatch, type SetStateAction, useCallback, useEffect, useState } from 'react';
import { Divider } from '@/app_components/SignIn/Components/SignInSharedComponents';
import { SocialSignInContainer } from '@/app_components/SignIn/SSO/SocialSignInContainer';
import { SocialSignInController } from '@/app_components/SignIn/SSO/SocialSignInController';
import type { SignInStatus, SocialLoginTypeError, SocialUrls } from '@/app_lib/types/accounts/signin';
import { clearSignInRedirectCookie, getSignInRedirectDestination } from '@/app_lib/utils/signinRedirect';

interface SocialSignInProps {
  setSignInStatus: Dispatch<SetStateAction<SignInStatus>>;
  socialLoginLoading: boolean;
  setSocialLoginLoading: Dispatch<SetStateAction<boolean>>;
  socialUrls: SocialUrls;
  disableSocialLogins: boolean;
}

export const SocialSignIn = ({
  disableSocialLogins,
  setSignInStatus,
  socialLoginLoading,
  setSocialLoginLoading,
  socialUrls,
}: SocialSignInProps) => {
  const [socialLoginTypeError, setSocialLoginTypeError] = useState<SocialLoginTypeError | null>(null);

  const handleSocialLoginSuccess = useCallback(
    (isRegistration: boolean) => {
      if (isRegistration) {
        setSignInStatus('Success');
      } else {
        const redirect = getSignInRedirectDestination();
        clearSignInRedirectCookie();
        window.location.href = redirect;
      }
    },
    [setSignInStatus],
  );

  useEffect(() => {
    if (!socialLoginTypeError) {
      return;
    }
    const dismiss = () => setSocialLoginTypeError(null);
    window.addEventListener('click', dismiss);
    return () => window.removeEventListener('click', dismiss);
  }, [socialLoginTypeError]);

  return (
    <>
      <Divider />
      <div className='w-full max-w-[340px]'>
        <SocialSignInController
          onLoadingChange={setSocialLoginLoading}
          onLoginError={setSocialLoginTypeError}
          onLoginSuccess={handleSocialLoginSuccess}
        >
          <SocialSignInContainer
            disableSocialLogins={disableSocialLogins}
            onLoadingChange={setSocialLoginLoading}
            socialLoginLoading={socialLoginLoading}
            socialLoginTypeError={socialLoginTypeError}
            socialUrls={socialUrls}
          />
        </SocialSignInController>
      </div>
    </>
  );
};
